import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "badge-wrpper" }
const _hoisted_2 = { class: "badge__label" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_5 = {
  key: 2,
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_6 = { class: "item-text" }

import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { TaskStatus } from "@/features/tasks/task.enum";
import { Archive, Check, CheckCircle, CheckCircleBroken } from "utruckin-icons";
// import { CircleCheck } from "lucide-vue-next";
import { IDropdown } from "@/types/main";

type StatusType = keyof typeof TaskStatus;

interface IStatusBadgeProps {
  status: string;
  label?: string;
  showActions?: boolean;
  isDisabled?: boolean;
  arrow?: boolean;
  items: IDropdown[];
  tooltipContent?: string;
  position: "top" | "bottom";
}

interface IStatusBadgeEmits {
  (e: "next"): void;

  (e: "confirm"): void;

  (e: "selected", v: IDropdown): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonStatus',
  props: {
    status: {},
    label: {},
    showActions: { type: Boolean, default: true },
    isDisabled: { type: Boolean, default: false },
    arrow: { type: Boolean, default: true },
    items: { default: () => [] },
    tooltipContent: {},
    position: { default: "bottom" }
  },
  emits: ["next", "confirm", "selected"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isOpen = ref(false);
const rootRef = ref<HTMLElement | null>(null);
const listStyle = ref({
  top: "0px",
  left: "0px",
  width: "200px",
  transformOrigin: "top",
});

const displayLabel = computed(() => {
  if (props.label) return props.label;
  const labels: Record<StatusType, string> = {
    NEW: "New",
    INFORM: "Inform",
    IN_PROGRESS: "In Progress",
    ON_HOLD: "On Hold",
    DONE: "Done",
    QA_FAILED: "Qa Failed",
    CLOSED: "Closed",
  };
  return labels[props.status];
});

// const hasArrow = computed(() => {
//   return (
//     props.showActions &&
//     props.arrow &&
//     ["NEW", "IN_PROGRESS"].includes(props.driver-status)
//   );
// });

const hasTick = computed(() => {
  return props.showActions && ["IN_PROGRESS"].includes(props.status);
});

const hasDropdown = computed(() => {
  return (
    props.showActions &&
    [
      "NEW",
      "INFORM",
      "IN_PROGRESS",
      "ON_HOLD",
      "QA_FAILED",
      "CLOSED",
      "DONE",
    ].includes(props.status)
  );
});

const displayDropdownItem = (name: string) => {
  const labels: any = {
    NEW: "New",
    INFORM: "Inform",
    IN_PROGRESS: "In Progress",
    ON_HOLD: "On Hold",
    DONE: "Done",
    QA_FAILED: "Qa Failed",
    CLOSED: "Closed",
    ARCHIVE: "Archive",
    REQUEST_CLOSE: "Request Close",
  };

  return labels[name];
};

const onNext = () => {
  if (props.isDisabled) return;
  emit("next");
};

const onConfirm = (e: any) => {
  e.stopPropagation();
  if (props.isDisabled) return;
  emit("confirm");
};

function updateListPosition() {
  if (!rootRef.value) return;
  const rect = rootRef.value.getBoundingClientRect();
  listStyle.value = {
    width: `${rect.width}px`,
    left: `${rect.left + window.scrollX}px`,
    top:
      props.position === "top"
        ? `${rect.top + window.scrollY - 6}px`
        : `${rect.bottom + window.scrollY + 6}px`,
    transformOrigin: props.position === "top" ? "bottom" : "top",
  };
}

const toggle = (e: any) => {
  e.stopPropagation();
  if (props.isDisabled) return;
  if (!props.showActions) return;
  if (!hasDropdown.value) return;
  if (!isOpen.value) {
    updateListPosition();
  }
  isOpen.value = !isOpen.value;
};

function choose(item: IDropdown) {
  emit("selected", item);
  isOpen.value = false;
}

function onDocumentClick(e: MouseEvent) {
  const el = rootRef.value;
  if (!el) return;
  const target = e.target as Node | null;
  if (!target) return;
  if (!el.contains(target)) {
    isOpen.value = false;
  }
}

onMounted(() => {
  document.addEventListener("click", onDocumentClick);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", onDocumentClick);
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "c-status-badge",
    ref_key: "rootRef",
    ref: rootRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["badge", [__props.status]]),
        onClick: toggle
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(displayLabel.value), 1)
      ], 2)), [
        [_directive_tooltip, {
          content: __props.tooltipContent,
          html: true,
        }]
      ])
    ]),
    (hasTick.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: _normalizeClass(["action-btn check-btn", { disabled: __props.isDisabled }]),
          onClick: onConfirm,
          "aria-label": "Confirm"
        }, [
          _createVNode(_unref(Check), { size: 18 })
        ], 2))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (isOpen.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "c-co-dropdown__list",
            style: _normalizeStyle({
          position: 'fixed',
          top: listStyle.value.top,
          left: listStyle.value.left,
          width: listStyle.value.width,
          transform: __props.position === 'top' ? 'translateY(-100%)' : 'none',
        })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.value || index,
                class: _normalizeClass(["c-co-dropdown__item", item.value == 'archive' ? 'archive' : '']),
                onClick: _withModifiers(($event: any) => (choose(item)), ["stop"])
              }, [
                (item.color)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "color-dot",
                      style: _normalizeStyle({ backgroundColor: `var(${item.color})` })
                    }, null, 4))
                  : _createCommentVNode("", true),
                (item.value == 'archive')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                      _createVNode(_unref(Archive), { size: 16 })
                    ]))
                  : _createCommentVNode("", true),
                (item.value === 'request_close')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                      _createVNode(_unref(CheckCircleBroken), { size: 16 })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_6, _toDisplayString(displayDropdownItem(item.name)), 1),
                (item.value === _ctx.modelValue)
                  ? (_openBlock(), _createBlock(_unref(Check), {
                      key: 3,
                      class: "check"
                    }))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_3))
            }), 128))
          ], 4))
        : _createCommentVNode("", true)
    ]))
  ], 512))
}
}

})